// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__tZg2N","link":"menu_link__PXBDZ","active":"menu_active__6GfGz"};